import { Box, Card, CardContent, Typography } from "@mui/material"
import React, { useEffect, useState } from "react"
import OTPInput from "react-otp-input"
import { authActions } from "../../redux/reducers/auth";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { useDispatch } from "react-redux";
import { otpfor2factor, resendOtp } from "../../API/authApi";
import API from "../../API/urlConstants";



const OtpScreen=()=>{
const navigate= useNavigate()
const dispatch=useDispatch()
 const [code, setCode] = useState("");
  const [timer, setTimer] = useState(60);
    const [trackResetTime, setTrackResetTime] = useState(false);
    const [isResendDisabled, setIsResendDisabled] = useState(false);
    const handleChange = (code) => setCode(code);
  
    const handleOtpSuccess = () => {
        dispatch(authActions.verifyOtp());
        navigate("/dashboard");
      };
    const renderInput = (input, i) => {
        return (
            <input
                {...input}
                key={input}
                type="text"
                maxLength="1"
                style={{
                    border: "1px solid #C7C6C6",
                    borderRadius: "8px",
                    width: "56px",
                    height: "56px",
                    fontSize: "25px",
                    color: "#000",
                    fontWeight: "400",
                    caretColor: "blue",
                    textAlign: "center",
                    marginLeft: "10px",
                    marginRight: "10px"
                }}
                className="otp-input"
            />
        );
    };
      const handleLogin = async () => {
    
          

            const persistedUser = localStorage.getItem("persist:user");

if (persistedUser) {
  const userObj = JSON.parse(persistedUser);

  // 'email' is stored as a stringified string (e.g., "\"upali.khanduri@resourcifi.com\"")
  const rawEmail = userObj.email;
  const email = JSON.parse(rawEmail); // This removes the outer escaped quotes
  const data = {
    email: email,
    otp: code,
};

            if (data.otp === '') {
                toast.error("Please enter OTP");
                return;
            }
            otpfor2factor(data)
                .then((response) => {
                    console.log({response})
                    // return
                              localStorage.setItem(API.AUTH_TOKEN, response.data?.data?.accessToken);
                              dispatch(authActions.verifyOtp(true));

                            //   isOtpVerified
                    navigate("/dashboard");

                    toast.success("OTP has been verified")
                })
                .catch((error) => toast.error(error?.message, {
                    autoClose: 5000, toastId: "otpsend"
                }))} else {
                    console.log("No user data found in localStorage.");
                  }
        };
    const handleSubmit = (event) => {
        event.preventDefault();
        handleLogin();
    };
       const handleSendAgain = async () => {
        const persistedUser = localStorage.getItem("persist:user");

        if (persistedUser) {
          const userObj = JSON.parse(persistedUser);
        
          // 'email' is stored as a stringified string (e.g., "\"upali.khanduri@resourcifi.com\"")
          const rawEmail = userObj.email;
          const email = JSON.parse(rawEmail); // This removes the outer escaped quotes
          const data = {
            email: email
        };
            const response = await resendOtp(data)
            if (response) {
                if (response.status === 200) {
                    toast.success("OTP sent successfully again");
                }
                else {
                    toast.error(response?.message);
                }
            }}
        }
    const handleResendClick = () => {

        setIsResendDisabled(true);
        setTrackResetTime(false);
        if (trackResetTime)
            handleSendAgain();
        setTimer(60);
    };
      useEffect(() => {
            if (timer > 0) {
                const interval = setInterval(() => {
                    setTimer(timer - 1);
                }, 1000);
    
                return () => clearInterval(interval);
            } else {
                setTrackResetTime(true);
                setIsResendDisabled(false);
            }
        }, [timer]);
    return(
           <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="100vh"
              className="gradient "
            >
              <div className="upperCircle  h-[847px] -top-[41vh] -left-[1496px] opacity-40  absolute">
                <div className="w-[800px] h-[800px]  bg-orange-700 rounded-full -top-[41vh] -left-[0.31vw] fixed" style={{
                  opacity: "20%", zIndex: 0
                }}></div>
                <div className="w-[800px] h-[800px]  bg-orange-700 rounded-full -top-[36vh] -left-[13vw] fixed " style={{
                  opacity: "20%", zIndex: 0, overflow: "hidden"
                }}></div>
              </div>
        
              <div className="lowerCircle  h-[847px] top-[67vh] left-[1378px] opacity-40 absolute">
                <div className="w-[800px] h-[800px]  bg-orange-700 rounded-full top-[61vh] left-[77vw] fixed" style={{
                  opacity: "20%", zIndex: 0,
                }}></div>
                <div className="w-[800px] h-[800px]  bg-orange-700 rounded-full top-[51vh] left-[85vw] fixed" style={{
                  opacity: "20%", zIndex: 0, overflow: "hidden"
                }}></div>
              </div>
        
              <Card style={{ borderRadius: "20px", zIndex: 2 }}>
                <CardContent className="login-card" style={{ padding: "36px" }}>
                  <div className="m-auto flex gap-[4.12px]">
        
                    <svg className="flex justify-center items-center mx-auto w-[142px] h-[90.51px] " viewBox="0 0 291 301" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M230.422 66.8766C230.422 79.4185 227.644 91.8047 222.288 103.145C216.931 114.486 209.13 124.499 199.443 132.466C189.756 140.433 178.426 146.155 166.264 149.222C154.103 152.288 141.414 152.623 129.108 150.203C116.802 147.782 105.185 142.665 95.0912 135.221C84.9978 127.776 76.6785 118.189 70.7312 107.147C64.784 96.1044 61.3563 83.8821 60.6945 71.3577C60.3324 64.5046 60.8033 57.6541 62.0823 50.9536C82.8684 50.7935 68.5377 50.9535 82.8684 50.7935C106.201 50.7935 106.201 50.7935 106.201 50.7935C103.826 56.5972 102.766 62.855 103.097 69.1172C103.428 75.3794 105.142 81.4905 108.115 87.0116C111.089 92.5326 115.248 97.3265 120.295 101.049C125.342 104.771 131.15 107.329 137.303 108.54C143.456 109.75 149.801 109.582 155.882 108.049C161.962 106.516 167.628 103.655 172.471 99.6712C177.314 95.6879 181.215 90.6812 183.893 85.0109C186.572 79.3406 187.961 73.1476 187.961 66.8766H230.422Z" fill="#FF6F29" />
                      <circle cx="209.192" cy="21.2307" r="21.2307" fill="#6D67D3" />
                      <circle cx="81.8069" cy="21.2307" r="21.2307" fill="#6D67D3" />
                      <path d="M146.561 50.9536H230.422V68.3628C230.422 77.5086 223.008 84.9228 213.862 84.9228H146.561V50.9536Z" fill="#FF6F29" />
                      <path d="M39.8089 300.957C29.6602 300.957 21.7119 298.936 15.964 294.894C10.2161 290.898 6.71341 285.913 5.45605 279.941L24.7206 277.381C25.3044 278.908 26.2249 280.322 27.4823 281.625C28.7397 282.927 30.4236 283.96 32.5342 284.723C34.6448 285.531 37.2268 285.936 40.2804 285.936C44.8159 285.936 48.5655 284.835 51.5293 282.635C54.4931 280.48 55.975 276.82 55.975 271.656V257.847H55.0993C54.2012 259.913 52.8316 261.889 50.9905 263.775C49.1493 265.661 46.7918 267.187 43.9178 268.355C41.0438 269.523 37.6085 270.106 33.6119 270.106C27.9538 270.106 22.8121 268.804 18.1868 266.2C13.6064 263.55 9.92417 259.509 7.14001 254.075C4.40076 248.641 3.03114 241.771 3.03114 233.463C3.03114 224.886 4.42321 217.746 7.20737 212.043C10.0364 206.34 13.7636 202.074 18.3889 199.245C23.0142 196.371 28.0885 194.934 33.6119 194.934C37.8331 194.934 41.3582 195.653 44.1872 197.09C47.0612 198.482 49.3963 200.233 51.1925 202.344C52.9888 204.454 54.3359 206.542 55.234 208.608H56.0423V195.877H76.5867V271.992C76.5867 278.369 75.015 283.713 71.8716 288.024C68.7282 292.335 64.3948 295.568 58.8714 297.723C53.348 299.879 46.9938 300.957 39.8089 300.957ZM40.2131 254.412C45.2425 254.412 49.1269 252.548 51.8661 248.821C54.6503 245.094 56.0423 239.93 56.0423 233.329C56.0423 228.928 55.4137 225.111 54.1563 221.878C52.9439 218.599 51.1701 216.062 48.835 214.266C46.4999 212.425 43.6259 211.504 40.2131 211.504C36.8002 211.504 33.9038 212.447 31.5238 214.333C29.1887 216.175 27.4149 218.734 26.2025 222.012C24.99 225.29 24.3838 229.063 24.3838 233.329C24.3838 237.64 24.99 241.389 26.2025 244.577C27.4149 247.721 29.1887 250.146 31.5238 251.852C33.9038 253.559 36.8002 254.412 40.2131 254.412ZM88.846 271.184V195.877H108.986V209.079H109.795C111.187 204.409 113.499 200.884 116.732 198.504C119.966 196.079 123.67 194.867 127.847 194.867C128.924 194.867 130.047 194.934 131.215 195.069C132.427 195.159 133.505 195.338 134.448 195.608V214.064C133.46 213.75 132.09 213.503 130.339 213.323C128.632 213.099 127.038 212.986 125.556 212.986C122.548 212.986 119.831 213.66 117.406 215.007C114.981 216.309 113.073 218.15 111.681 220.53C110.333 222.866 109.66 225.56 109.66 228.613V271.184H88.846ZM159.977 272.599C155.217 272.599 150.928 271.768 147.111 270.106C143.339 268.4 140.375 265.885 138.22 262.562C136.064 259.239 134.987 255.108 134.987 250.168C134.987 245.947 135.75 242.444 137.277 239.66C138.804 236.831 140.892 234.541 143.541 232.79C146.191 231.038 149.199 229.714 152.567 228.816C155.935 227.917 159.505 227.289 163.277 226.929C167.633 226.525 171.136 226.121 173.785 225.717C176.435 225.313 178.366 224.707 179.578 223.898C180.835 223.045 181.464 221.833 181.464 220.261V219.924C181.464 216.826 180.476 214.423 178.5 212.717C176.569 211.01 173.83 210.157 170.283 210.157C166.555 210.157 163.569 210.988 161.324 212.649C159.123 214.266 157.664 216.332 156.946 218.846L137.614 217.297C138.602 212.717 140.532 208.765 143.406 205.442C146.28 202.074 149.985 199.492 154.521 197.696C159.101 195.855 164.4 194.934 170.417 194.934C174.593 194.934 178.59 195.428 182.407 196.416C186.224 197.404 189.614 198.931 192.578 200.996C195.587 203.017 197.967 205.644 199.718 208.877C201.47 212.111 202.345 215.95 202.345 220.396V271.184H182.474V260.676H181.936C180.723 263.056 179.106 265.144 177.086 266.94C175.065 268.692 172.64 270.084 169.811 271.117C166.982 272.105 163.704 272.599 159.977 272.599ZM165.972 258.184C169.025 258.184 171.719 257.578 174.055 256.365C176.435 255.108 178.276 253.446 179.578 251.381C180.925 249.27 181.599 246.913 181.599 244.308V236.292C180.97 236.696 180.072 237.078 178.904 237.437C177.782 237.797 176.524 238.111 175.132 238.38C173.74 238.65 172.348 238.897 170.956 239.121C169.564 239.301 168.307 239.481 167.184 239.66C164.714 240.02 162.559 240.603 160.718 241.412C158.876 242.175 157.439 243.23 156.407 244.577C155.419 245.88 154.925 247.519 154.925 249.495C154.925 252.324 155.958 254.479 158.023 255.961C160.089 257.443 162.738 258.184 165.972 258.184ZM254.481 195.877V211.639H209.148V195.877H254.481ZM219.454 177.96H240.268V248.013C240.268 250.527 240.829 252.391 241.952 253.603C243.075 254.771 244.871 255.355 247.341 255.355C248.149 255.355 249.047 255.287 250.035 255.153C251.023 255.018 251.876 254.861 252.595 254.681L255.895 270.308C253.605 270.982 251.382 271.476 249.227 271.79C247.116 272.105 245.028 272.262 242.962 272.262C235.463 272.262 229.67 270.398 225.584 266.671C221.497 262.899 219.454 257.6 219.454 250.774V177.96ZM263.574 271.184V195.877H284.388V271.184H263.574ZM273.947 186.245C270.849 186.245 268.199 185.212 265.999 183.146C263.799 181.081 262.698 178.588 262.698 175.67C262.698 172.751 263.799 170.281 265.999 168.26C268.199 166.194 270.849 165.162 273.947 165.162C277.091 165.162 279.763 166.194 281.963 168.26C284.163 170.281 285.264 172.751 285.264 175.67C285.264 178.588 284.163 181.081 281.963 183.146C279.763 185.212 277.091 186.245 273.947 186.245Z" fill="#1D1546" />
                    </svg>
        
                  </div>
                  <div className="frame2" style={{ marginTop: "30px", gap: "4px", textAlign: "center" }}>
                    <Typography
                      sx={{
                        fontFamily: "Plus Jakarta Sans,sans-serif",
                        fontSize: "28px",
                        lineHeight: "39px",
                        fontWeight: "800",
                      }}
                    >
                      Welcome to Grati!
                    </Typography>
                    <p className="text-[18px] font-[400] text-[#888888]" style={{ fontFamily: "Plus Jakarta Sans,sans-serif" }}
                    >
                      Please enter the below details in order to login.
                    </p>
                  </div>
                  <div className="frame3">
                  <div className="frame3">
                        <form onSubmit={handleSubmit} style={{ marginTop: "20px" }}>
                            <OTPInput
                                value={code}
                                onChange={handleChange}
                                numInputs={6}
                                separator={<span style={{ width: "8px" }}></span>}
                                isInputNum={true}
                                shouldAutoFocus={true}
                                inputStyle={{
                                    border: "1px solid transparent ",
                                    borderRadius: "8px",
                                    width: "54px",
                                    height: "54px",
                                    color: "#000",
                                    fontWeight: "400",
                                    caretColor: "blue",
                                    fontSize: "12px",

                                }}
                                focusStyle={{
                                    border: "1px solid transparent",
                                    outline: "none",
                                }}
                                renderInput={renderInput}
                            />

                            <div className="flex flex-col gap-5 mt-5">
                                <div className="flex flex-row justify-center items-center gap-5">
                                    <div>
                                        {timer > 0 ? `Resend OTP in ${timer} seconds` : "You can now resend OTP"}
                                    </div>
                                    <button
                                     style={{
                                        fontFamily: "Plus Jakarta Sans, sans-serif",
                                        fontWeight: trackResetTime ? "700" : "500",
                                        textSize: "16px",
                                        padding: "0",
                                        color: trackResetTime ? "black" : "gray",
                                        cursor: trackResetTime ? "pointer" : "default",
                                    }}
                                        className="font-bold text-black text-center cursor-pointer"
                                        onClick={handleResendClick} disabled={isResendDisabled}
                                    >
                                        Resend
                                    </button>
                                </div>
                                <button type="submit" className="login-btn mt-5">
                                    <span
                                        className="font-bold text-white"
                                        style={{
                                            fontFamily: "Plus Jakarta Sans, sans-serif",
                                            fontWeight: "700",
                                            textSize: "16px",
                                            padding: "0",
                                        }}
                                    >
                                        Submit Confirmation Code
                                    </span>
                                </button>

                            </div>

                        </form>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Box>
    )
}

export default OtpScreen